import React, { useState } from "react";
import ChatDrawer from "./ChatDrawer";
import { API_CONFIG } from "../../utils/apiConfig";

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Compact Floating Action Launcher */}
      {!isOpen && (
        <div className="fixed bottom-6 right-6 z-40 flex items-center">
          <button
            onClick={() => setIsOpen(true)}
            title="Open AI Assistant"
            className="group relative flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-r from-primary-600 to-amber-600 text-white shadow-lg shadow-primary-600/30 ring-2 ring-primary-500/20 transition-all duration-300 hover:scale-110 hover:shadow-xl active:scale-95"
            aria-label="Open AI Assistant"
          >
            {/* Live Green Status Beacon */}
            <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-3 w-3 rounded-full bg-emerald-500 border-2 border-white dark:border-slate-900" />
            </span>

            {/* Sparkle / Bot Icon */}
            <svg
              className="h-6 w-6 transition-transform duration-300 group-hover:scale-110"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </button>
        </div>
      )}



      {/* Slide-over Drawer Panel */}
      <ChatDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
